import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, type SafeHtml } from '@angular/platform-browser';

/** Bypass Angular XSS defenses and mark the given HTML string as trusted. */
@Pipe({ name: 'trustedHtml', standalone: true })
export class TrustedHtmlPipe implements PipeTransform {
	private readonly sanitizer = inject(DomSanitizer);

	/** Bypass Angular XSS defenses and mark the given HTML string as trusted. */
	transform(html: string): SafeHtml {
		return this.sanitizer.bypassSecurityTrustHtml(html);
	}
}
